import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import VisionSection from "@/components/VisionSection";
import SolutionsSection from "@/components/SolutionsSection";
import ManufacturingSection from "@/components/ManufacturingSection";
import IndustriesSection from "@/components/IndustriesSection";
import WhyChooseSection from "@/components/WhyChooseSection";
import ShardaGroupPreviewSection from "@/components/ShardaGroupPreviewSection";
import ContactSection from "@/components/ContactSection";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <AboutSection />
      <VisionSection />
      <SolutionsSection />
      <ManufacturingSection />
      <IndustriesSection />
      <WhyChooseSection />
      <ShardaGroupPreviewSection />
      <ContactSection />
    </main>
  );
}
